import { useEffect, useState } from "react";
import { Printer } from "lucide-react";
import { desktop, getPrinters, savePrinters, silentPrint } from "../lib/desktopPrint";

// Shown only inside the FynDine Windows app. Settings are saved on this PC.
export function PrinterSettings() {
  const [list, setList] = useState([]);
  const [p, setP] = useState(getPrinters());
  const [msg, setMsg] = useState("");
  useEffect(() => { desktop()?.printers().then((x) => setList(x || [])).catch(() => {}); }, []);
  if (!desktop()) return null;
  const set = (k, v) => { const n = { ...p, [k]: v }; setP(n); savePrinters(n); setMsg("Saved on this PC"); };
  const sel = (k, testid) => <select value={p[k] || ""} onChange={(e) => set(k, e.target.value)} data-testid={testid}><option value="">— Show print dialog —</option>{list.map((x) => <option key={x.name} value={x.name}>{x.displayName || x.name}</option>)}</select>;
  const test = async () => setMsg((await silentPrint("bill", "<html><body style='font-family:monospace'><h3>FynDine test print</h3><p>Printer is working.</p></body></html>")) ? "Test sent to the bill printer" : "Pick a bill printer first");
  return (
    <section className="panel" data-testid="printer-settings" style={{ marginTop: 18 }}>
      <div className="panel-head"><div><span className="overline">THIS PC · WINDOWS APP</span><h2><Printer size={16} /> Thermal printers</h2></div></div>
      <div className="form-grid">
        <label>KOT printer (kitchen){sel("kot_printer", "printer-kot")}</label>
        <label>Bill printer (counter){sel("bill_printer", "printer-bill")}</label>
        <label>Paper width<select value={p.width || 80} onChange={(e) => set("width", Number(e.target.value))} data-testid="printer-width"><option value={80}>80 mm</option><option value={58}>58 mm</option></select></label>
        <label className="check-row"><input type="checkbox" checked={!!p.auto_kot} onChange={(e) => set("auto_kot", e.target.checked)} data-testid="printer-auto-kot" /> Print every new KOT automatically on this PC</label>
      </div>
      <div className="setup-actions"><button className="secondary-button" onClick={test} data-testid="printer-test">Test bill printer</button>{msg && <span className="form-hint" data-testid="printer-msg">{msg}</span>}</div>
    </section>
  );
}
